import { ldFlagStorageKey } from "./storage-key.js";
import { getLocalItem } from "@myphx-engineering/browser-utils";

//#region src/client/get-overridden-flags.ts
const getOverriddenFlagsFromStorage = () => {
	try {
		const flags = getLocalItem(ldFlagStorageKey);
		if (typeof flags === "object" && flags !== null && !Array.isArray(flags)) return flags;
	} catch {}
	return {};
};

//#endregion
export { getOverriddenFlagsFromStorage };